import { identity } from "lodash";
import { makeAutoObservable } from "mobx";
import { RadioFieldModel } from "@/common/commonForms";
import { Language, languageLabel } from "@/i18n/languages";

export type ExportTransactionsData = {
  language: Language;
};

export class ExportTransactionsModel {
  exportStatus: "init" | "loading" | "success" | "error" = "init";
  language: RadioFieldModel<Language>;
  onSubmit: (data: ExportTransactionsData, onSuccess: () => void, onFailure: () => void) => void;
  onClose: () => void;

  constructor(
    onSubmit: (data: ExportTransactionsData, onSuccess: () => void, onFailure: () => void) => void,
    onClose: () => void,
    initialLanguage: Language,
  ) {
    this.onSubmit = onSubmit;
    this.onClose = onClose;
    this.language = new RadioFieldModel({
      value: initialLanguage,
      options: Object.values(Language),
      labelFn: languageLabel,
      idFn: identity,
      disabledFn: () => this.isLoading,
    });
    makeAutoObservable(this, {}, { autoBind: true });
  }

  handleSubmitExport() {
    this.setExportStatus("loading");
    this.onSubmit(
      { language: this.language.value },
      () => {
        this.setExportStatus("success");
        this.onClose();
      },
      () => this.setExportStatus("error"),
    );
  }

  setExportStatus(status: "init" | "loading" | "success" | "error") {
    this.exportStatus = status;
  }

  get isLoading() {
    return this.exportStatus === "loading";
  }
}
